export default __webpack_public_path__ + "static/media/Boots of the Unutterable.0d2e3400.jpg";